<template>
  <div class="messageBox">
    <div class="messageBox-wrap">
      <div class="title">{{mesBoxTitle.title}}</div>
      <!-- 预约上门 -->
      <div class="content" v-if="mesBoxType == 1 || mesBoxType == 5">
        <div class="item">
          <div class="subTitle">{{mesBoxTitle.subTitle}}</div>
          <div class="itemInput" >
            <div class="font-size-14px" style="align-self: center;" @click="selectData(2)">{{pickerValuenew || '请选择时间'}}</div>
            <mt-datetime-picker ref="picker" type="datetime" :startDate="startDate" :endDate="endDate" v-model="selectedValue" @confirm="handleConfirm"></mt-datetime-picker>
          </div>
        </div>
      </div>
      <!-- 疑难延期 -->
      <div class="content" v-if="mesBoxType == 2">
        <div class="item">
          <div class="subTitle">预计处理时间：</div>
          <div class="itemInput" >
            <div class="font-size-14px" style="align-self: center;" @click="selectData(2)">{{pickerValuenew || '请选择时间'}}</div>
            <mt-datetime-picker ref="picker" type="datetime" :startDate="startDate" :endDate="endDate" v-model="selectedValue" @confirm="handleConfirm"></mt-datetime-picker>
          </div>
        </div>
        <div class="item">
          <div class="subTitle">疑难情况说明：</div>
          <div class="itemInput" >
            <textarea class="Textarea" elastic placeholder="请您输入疑难情况说明" maxlength="100" v-model="explain"></textarea>
          </div>
        </div>
      </div>
      <!-- 完成维修 -->
      <div class="content" v-if="mesBoxType == 3">
        <div class="item">
          <div class="subTitle">故障原因：</div>
          <div class="itemInput dropdownBox">
            <div id="Dropdown" :class="{'color-666': !dropdownData.value}" class="dropdown font-size-14px">{{dropdownData.name}}</div>
            <img class="dropArrow" src="static/images/arrow-right.png">
          </div>
        </div>
        <div class="item" v-if="dropdownData.name == '手动填写'">
          <div class="subTitle">手动填写故障原因：</div>
          <div class="itemInput" >
            <textarea  class="Textarea" elastic placeholder="请输入手动填写内容" maxlength="100" v-model="sdFillIn"></textarea>
          </div>
        </div>
        <div class="item">
          <div class="subTitle">备注：</div>
          <div class="itemInput" >
            <textarea  class="Textarea" elastic placeholder="请输入备注" maxlength="100" v-model="remarks"></textarea>
          </div>
        </div>
      </div>
      <!-- 问题描述 -->
      <div class="content" v-if="mesBoxType == 4 || mesBoxType == 7">
        <!-- <div class="item">
          <div class="subTitle">{{mesBoxTitle.subTitle}}</div>
          <div class="itemInput" >
            <textarea  class="Textarea" elastic placeholder="请输入备注" maxlength="100" v-model="remarks"></textarea>
          </div>
        </div> -->

        <div class="item">
          <div class="subTitle">{{mesBoxTitle.subTitle}}</div>
          <div class="itemInput dropdownBox">
            <div id="Dropdown" :class="{'color-666': !dropdownData.value}" class="dropdown font-size-14px">{{dropdownData.name}}</div>
            <img class="dropArrow" src="static/images/arrow-right.png">
          </div>
        </div>
        <div class="item" v-if="dropdownData.name == '其他'">
        <!-- <div class="item"> -->
          <div class="subTitle">其他</div>
          <div class="itemInput" >
            <textarea  class="Textarea" elastic placeholder="请输入其他描述" maxlength="100" v-model="remarks"></textarea>
          </div>
        </div>
      </div>
      <!-- 完成维修 -->
      <div class="content" v-if="mesBoxType == 6">
        <div class="item">
          <div class="subTitle">满意度：</div>
          <div class="itemInput dropdownBox">
            <div id="Dropdown" :class="{'color-666': !dropdownData.value}" class="dropdown font-size-14px">{{dropdownData.name}}</div>
            <img class="dropArrow" src="static/images/arrow-right.png">
          </div>
        </div>
        <div class="item">
          <div class="subTitle">意见描述</div>
          <div class="itemInput" >
            <textarea  class="Textarea" elastic placeholder="请输入意见描述" maxlength="100" v-model="remarks"></textarea>
          </div>
        </div>
      </div>
      <!-- footer -->
      <div class="footerBtn">
        <div class="btn bg-appStyle" @click="onCancel($event)">取消</div>
        <div class="btn bg-appStyle" @click="onSubmit($event)">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {formatDateTime} from '@/util/filter';
import service from "@/fetch/service";
import MobileSelect from 'mobile-select';
import { Toast } from 'mint-ui';
export default {
  name: 'messagebox',
  props: {
    mesBoxType: {
      type: Number,
      default: 1
    },
    mesBoxTitle: {
      type: Object,
      default: () => (
          {
            title: '预约上门',
            subTitle: '约定上门时间:'
          }
      )
    }
  },
  data() {
    return {
      startDate: new Date(),
      endDate: new Date(new Date().getTime() + (86400000*2)),
      pickerValue: '',
      pickerValuenew: '',
      selectedValue: '',
      explain: '', //说明
      sdFillIn: '', //手动填写内容
      remarks: '', // 备注
      dropdownDataArr: [
        {
          id: '',
          value: '请选择故障'
        }
      ],
      dropdownData: { //当前下拉框的值
        name: '请选择故障',
        value: ''
      }
    };
  },
  computed: {

  },
  mounted() {
    let that = this;
    if (that.mesBoxType == 6) {
      that.dropdownDataArr = [ //满意度
        {
          id: '1',
          value: '满意'
        },
        {
          id: '2',
          value: '不满意'
        }
      ]
      that.dropdownData = { //满意度
        name: '满意',
        value: '1'
      }
      var mobileSelect = new MobileSelect({
        trigger: "#Dropdown",
        title: "满意度填写",
        wheels: [
          {data: that.dropdownDataArr}
        ],
        callback:function(indexArr, data){
            console.log(data);
            that.dropdownData = {
              name: data[0].value,
              value: data[0].id
            }
        }
      });
    }
    if (that.mesBoxType == 4 || that.mesBoxType == 7) {
      if (that.mesBoxType == 4) {
        that.dropdownDataArr = [ //融合套餐 有问题 无问题说明
        {
          id: '',
          value: '请选择'
        },
        {
          id: '1',
          value: '账号欠费'
        },
        {
          id: '2',
          value: '其他'
        }
      ]
      }else {
        that.dropdownDataArr = [ //融合套餐 有问题 无问题说明
        {
          id: '',
          value: '请选择'
        },
        {
          id: '1',
          value: '账号正常'
        },
        {
          id: '2',
          value: '账号问题已解决'
        },
        {
          id: '3',
          value: '其他'
        }
      ]
      }
      
      that.dropdownData = { 
        name: '请选择',
        value: ''
      }
      var mobileSelect = new MobileSelect({
        trigger: "#Dropdown",
        title: "诊断说明",
        wheels: [
          {data: that.dropdownDataArr}
        ],
        callback:function(indexArr, data){
            
            that.dropdownData = {
              name: data[0].value,
              value: data[0].id
            }
            console.log(that.dropdownData.name);
            console.log(that.dropdownData.value);
        }
      });
    }
  },
  created() {
    console.log(this.mesBoxTitle.title)
    if (this.mesBoxType == 3) {
      console.log("getProblem")
      this.getProblem();
    }
  },
  methods: {
    //时间选择
    selectData() { // 打开时间选择器
      // 如果已经选过日期，则再次打开时间选择器时，日期回显（不需要回显的话可以去掉 这个判断）
      if (this.pickerValue) {
        this.selectedValue = this.pickerValue
      }else {
        this.selectedValue = new Date()
      }
      this.$refs['picker'].open()
    },
    handleConfirm() { // 时间选择器确定按钮，并把时间转换成我们需要的时间格式
      this.pickerValue = formatDateTime(this.selectedValue)
      console.log(this.pickerValue)
      this.pickerValuenew = String(this.pickerValue);
    },
    //获取故障原因
    getProblem() {
      let that = this
      this.$store.dispatch("setLoadingState", true);
      service
      .findErrorType()
      .then(res => {
        this.$store.dispatch("setLoadingState", false);
        let result = res.result;
        if (res.success) {
          that.dropdownDataArr = [
            {
              id: '',
              value: '请选择故障'
            }
          ];
          that.dropdownData = { //当前下拉框的值
            name: '请选择故障',
            value: ''
          };
          result.forEach(element => {
            that.dropdownDataArr.push({
             id: element.value,
             value: element.name 
            })
          });
          that.dropdownDataArr.push({
             id: '0',
             value: '手动填写'
            })
          var mobileSelect = new MobileSelect({
            trigger: "#Dropdown",
            title: "请选择故障",
            wheels: [
              {data: that.dropdownDataArr}
            ],
            callback:function(indexArr, data){
                console.log(data);
                that.dropdownData = {
                  name: data[0].value,
                  value: data[0].id
                }
            }
          });
          
        }
        
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.data.msg);
      });
    },
    /**
     * 提交
     */
    onSubmit(event){
      event.stopPropagation();
      if ((this.mesBoxType == 1 && !this.pickerValuenew) || 
      (this.mesBoxType == 2 && !this.pickerValuenew) ||
      (this.mesBoxType == 5 && !this.pickerValuenew)) {
        Toast("请选择时间");
        return;
      }
      if (this.mesBoxType == 2 && !this.explain) {
        Toast("请写说明");
        return;
      }
      if (this.mesBoxType == 3 && !this.dropdownData.value) {
        Toast("请选择原因");
        return;
      }
      // if (this.mesBoxType == 3 && !this.remarks) {
      //   Toast("请填写备注／说明");
      //   return;
      // }
      if (this.mesBoxType == 3 && this.dropdownData.name == '手动填写' && !this.sdFillIn) {
        Toast("请手动填写内容");
        return;
      }
      if ((this.mesBoxType == 4 && !this.dropdownData.value) || (this.mesBoxType == 7 && !this.dropdownData.value)) {
        Toast("请选择诊断说明");
        return;
      }
      if (this.dropdownData.name == '其他' && !this.remarks) {
          Toast("请填写诊断说明");
          return;
        }

      let typeName = '预约上门';
      if (this.mesBoxType == 2) {
        typeName = '疑难延期'
      }
      if (this.mesBoxType == 3) {
        typeName = '完成维修'
        if (this.dropdownData.name == '手动填写') {
          this.dropdownData.value = this.sdFillIn;
        }
      }
      if (this.mesBoxType == 4) {
        typeName = '有问题'
      }
      if (this.mesBoxType == 5) {
        typeName = '修改时间'
      }
      if (this.mesBoxType == 6) {
        typeName = '满意度'
      }
      if (this.mesBoxType == 7) {
        typeName = '无问题'
      }

      let data = {
        btnType: this.mesBoxType,
        typeName: typeName,
        time: this.pickerValuenew, // 时间
        explain: this.explain, // 说明
        remarks: this.remarks, // 备注
        reason: this.dropdownData //原因
      }
      this.$emit("change", data);
    },
    /**
     * 取消
     */
    onCancel(event){
      event.stopPropagation();
      let data = {
        btnType: '2'
      }
      this.$emit("change", data);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/function";
.dropdownBox {
  display: flex;
  align-items: center;
  padding: 0 px2rem(5px);
  .dropdown {
    width: px2rem(250px);
    flex: 1;
  }
  .dropArrow {
    width: px2rem(40px);
    height: px2rem(40px);
  }
}
.footerBtn {
  width: 100%;
  height: px2rem(80px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  .btn {
    width: 50%;
    text-align: center;
    height: px2rem(80px);
    line-height: px2rem(80px);
  }
  .btn:first-child {
    border-right: 1px solid #ddd;
  }
}
.messageBox {
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  font-size: 14px;
  .messageBox-wrap {
    position: fixed;
    width: 90%;
    height: auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border: 1px solid #ddd;
    .title {
      height: px2rem(70px);
      line-height: px2rem(70px);
      border-bottom: 1px solid #ddd;
      text-align: center;
      font-size: px2rem(28px);
      font-weight: bold;
    }
    .content {
      background: #fff !important;
      padding: px2rem(20px);
      .item {
        margin-top: px2rem(20px);
        .subTitle {
          font-size: 14px;
          font-weight: bold;
        }
        .itemInput {
          margin-top: px2rem(15px);
          padding: px2rem(20px) px2rem(15px);
          border: 1px solid #ddd;
          .Textarea {
            width: 100%;
            border: none;
          }
        }
      }
      
      
    }
  }
}
</style>


// WEBPACK FOOTER //
// messagebox.vue?1ac7fff2